// src/AnswerPreview.tsx
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { jsx } from "react/jsx-runtime";
var BR_ONLY_RE = /^(?:<br\s*\/?>\s*)+$/i;
var BR_TAG_RE = /<br\s*\/?>/gi;
function remarkBreakTags() {
  return (tree) => {
    const visit = (node) => {
      if (!Array.isArray(node.children)) return;
      for (let i = 0; i < node.children.length; i += 1) {
        const child = node.children[i];
        if (child?.type === "html" && typeof child.value === "string" && BR_ONLY_RE.test(child.value.trim())) {
          const count = (child.value.match(BR_TAG_RE) || []).length;
          const breaks = Array.from({ length: count }, () => ({ type: "break" }));
          node.children.splice(i, 1, ...breaks);
          i += breaks.length - 1;
        } else if (child && typeof child === "object") {
          visit(child);
        }
      }
    };
    visit(tree);
  };
}
var PREVIEW_DISALLOWED_ELEMENTS = [
  "a",
  "img",
  "pre",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "hr",
  "iframe",
  "script",
  "style"
];
var PREVIEW_COMPONENTS = {
  p: ({ children }) => /* @__PURE__ */ jsx("p", { className: "m-0 break-words", children }),
  h1: ({ children }) => /* @__PURE__ */ jsx("h1", { className: "text-base font-bold m-0 break-words", children }),
  h2: ({ children }) => /* @__PURE__ */ jsx("h2", { className: "text-base font-bold m-0 break-words", children }),
  h3: ({ children }) => /* @__PURE__ */ jsx("h3", { className: "text-[15px] font-bold m-0 break-words", children }),
  h4: ({ children }) => /* @__PURE__ */ jsx("h4", { className: "text-[15px] font-bold m-0 break-words", children }),
  h5: ({ children }) => /* @__PURE__ */ jsx("h5", { className: "text-sm font-bold m-0 break-words", children }),
  h6: ({ children }) => /* @__PURE__ */ jsx("h6", { className: "text-xs font-bold m-0 break-words", children }),
  code: ({ children }) => /* @__PURE__ */ jsx("code", { className: "photon-code-inline", children }),
  ul: ({ children }) => /* @__PURE__ */ jsx("ul", { className: "revert-list-style ml-5 sm:ml-6 m-0 break-words", children }),
  ol: ({ children }) => /* @__PURE__ */ jsx("ol", { className: "revert-list-style ml-5 sm:ml-6 m-0 break-words", children }),
  li: ({ children }) => /* @__PURE__ */ jsx("li", { className: "revert-list-style m-0 break-words", children }),
  blockquote: ({ children }) => /* @__PURE__ */ jsx("blockquote", { className: "border-l-4 border-edge-border dark:border-edge-muted-control pl-3 italic m-0 break-words", children })
};
var AnswerPreview = ({
  content,
  remarkPlugins = [remarkGfm],
  rehypePlugins
}) => /* @__PURE__ */ jsx("div", { className: "relative overflow-hidden", children: /* @__PURE__ */ jsx("div", { className: "photon-markdown photon-chat-message photon-chat-message--page photon-chat-message--assistant break-words font-inter text-[15px] leading-6 sm:leading-7 line-clamp-4", children: /* @__PURE__ */ jsx(
  ReactMarkdown,
  {
    remarkPlugins: [...remarkPlugins ?? [], remarkBreakTags],
    rehypePlugins,
    disallowedElements: PREVIEW_DISALLOWED_ELEMENTS,
    unwrapDisallowed: true,
    skipHtml: true,
    components: PREVIEW_COMPONENTS,
    children: content
  }
) }) });
var AnswerPreview_default = AnswerPreview;
export {
  AnswerPreview_default as default
};
